import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/feed";

const COPY = {
  loading: ["One moment…", "Updating your preferences."],
  done: ["You're unsubscribed.", "You won't get the HostNode weekly roundup any more. You can sign up again on the homepage anytime."],
  error: ["That link didn't work.", "It may be old or already used. If you keep getting emails, reply to one and we'll remove you."],
};

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const token = params.get("token");
    if (!token) return setStatus("error");
    axios
      .post(`${API}/subscribers/unsubscribe`, null, { params: { token } })
      .then(() => setStatus("done"))
      .catch(() => setStatus("error"));
  }, [params]);

  const [title, body] = COPY[status];
  return (
    <div data-testid="unsubscribe-page" className="grain flex min-h-screen flex-col justify-center px-6 md:px-20">
      <a href="/" className="font-display text-2xl font-semibold">HostNode</a>
      <h1 data-testid="unsubscribe-title" className="font-display text-4xl sm:text-5xl lg:text-6xl font-light mt-10">{title}</h1>
      <p data-testid="unsubscribe-message" className="mt-6 max-w-lg text-[var(--ash)]">{body}</p>
      <a href="/" data-testid="unsubscribe-home-link" className="mt-10 text-sm text-[var(--volt)] hover:underline underline-offset-8">Back to HostNode →</a>
    </div>
  );
}
